<!--MultiSelect:带有“全选”按钮的多选下拉框 2024/09/20 11:39:10 YuAng-->

<template>
  <el-select v-model="selectItems" @change="selectRateChange" multiple filterable class="multi-select" size="mini" collapse-tags :placeholder="placeholder">
    <el-option label="全选" value="ALL"></el-option>
    <el-option v-for="opt in items" :key="opt.value" :label="opt.name" :value="opt.value"></el-option>
  </el-select>
</template>
<script>
export default {
  name: 'MultiSelect',
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    defaultAll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectItems: [],
      oldSelectItems: [],
    }
  },
  mounted () {
    if (this.defaultAll) {
      this.setAll()
    }
  },
  methods: {
    setAll () {
      this.setSelectItems(['ALL'])
    },
    setSelectItems (selectItems, change = true) {
      this.oldSelectItems = []
      this.selectItems = selectItems
      if (change) {
        this.selectRateChange()
      }
    },
    selectRateChange () {
      const list = this.selectItems
      if (list.includes('ALL')) {
        // 在全选的情况下，取消某个选项，则设置取消“全选”选项
        if (this.oldSelectItems && this.oldSelectItems.length - 1 === this.items.length) {
          this.selectItems = list.filter(item => item !== 'ALL')
          // 在没全选的情况下，选择“全选”选项
        } else {
          this.selectItems = ['ALL']
          for (let index = 0; index < this.items.length; index++) {
            const rate = this.items[index];
            this.selectItems.push(rate.value)
          }
        }
      } else {
        // 在全选的情况下，取消“全选”选项
        if (this.oldSelectItems.includes('ALL') && !list.includes('ALL')) {
          this.selectItems = []
        } else if (list.length && list.length === this.items.length) {
          this.selectItems.unshift('ALL')
        }
      }
      this.oldSelectItems = this.selectItems
      this.$emit('change', this.selectItems.filter(item => item !== 'ALL'))
    }
  }
}
</script>

<style scoped>
.multi-select ::v-deep .el-tag__close.el-icon-close {
  right: -4px;
}
</style>
